export class ValidarIMEI {
  private sumarDigitosImei(n: number): number {
    let a: number = 0;
    while (n > 0) {
      a = a + (n % 10);
      let div: string = (n / 10).toString();
      n = parseInt(div, 0);
    }
    return a;
  }

  validar(s: string): boolean {
    let n: number = parseInt(s);

    return n > 0;
  }
}
